import React, { useState, } from 'react';

const SUB_TYPES = [
  { value: '', display: 'Select retry type...', },
  { value: 'all', display: 'Entire Transaction', },
  { value: 'single', display: 'Single Line Item', },
];

const WaterRetryForm = ({ loading, onSubmit, }) => {
  const [subType, setSubType] = useState('');
  const [serviceOfferingId, setServiceOfferingId] = useState('');
  const [transactionId, setTransactionId] = useState('');
  const [lineItemId, setLineItemId] = useState('');
  const [externalPayableId, setExternalPayableId] = useState('');
  const [forceRepostToClient, setForceRepostToClient] = useState(false);

  const onSubTypeChange = (e) => {
    setSubType(e.target.value);
    setServiceOfferingId('');
    setTransactionId('');
    setLineItemId('');
    setExternalPayableId('');
    setForceRepostToClient(false);
  };

  const isValid = () => {
    if (!subType || !serviceOfferingId.trim() || !transactionId.trim()) {
      return false;
    }
    if (subType === 'single' && (!lineItemId.trim() || !externalPayableId.trim())) {
      return false;
    }
    return true;
  };

  const getUrl = () => {
    const soId = serviceOfferingId.trim() || '{serviceOfferingId}';
    const tId = transactionId.trim() || '{transactionId}';
    const base = `/serviceOfferingId/${soId}/bills/transaction/${tId}`;
    const lineItems = subType === 'single'
      ? `/lineItemId/${lineItemId.trim() || '{lineItemId}'}/externalPayableId/${externalPayableId.trim() || '{externalPayableId}'}`
      : '';
    const query = `/manual?forceRepostToClient=${forceRepostToClient}`;
    return `${base}${lineItems}${query}`;
  };

  const handleSubmit = () => {
    if (!isValid()) return;
    onSubmit({
      subType,
      serviceOfferingId: serviceOfferingId.trim(),
      transactionId: transactionId.trim(),
      lineItemId: lineItemId.trim(),
      externalPayableId: externalPayableId.trim(),
      forceRepostToClient,
    });
  };

  return (
    <div className='mt-3'>
      <div className='mb-3'>
        <label htmlFor='waterSubType'>Retry Type</label>
        <select
          id='waterSubType'
          className='form-select'
          value={subType}
          onChange={onSubTypeChange}
          disabled={loading}
        >
          {SUB_TYPES.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.display}</option>
          ))}
        </select>
      </div>
      {subType && (
        <div className='mt-4 py-3 px-4 border rounded'>
          <div className='mb-3'>
            <label htmlFor='serviceOfferingId'>Service Offering ID</label>
            <input
              id='serviceOfferingId'
              type='text'
              className='form-control'
              placeholder='Enter service offering ID'
              value={serviceOfferingId}
              onChange={(e) => setServiceOfferingId(e.target.value)}
              disabled={loading}
            />
          </div>
          <div className='mb-3'>
            <label htmlFor='transactionId'>Transaction ID</label>
            <input
              id='transactionId'
              type='text'
              className='form-control'
              placeholder='Enter transaction ID'
              value={transactionId}
              onChange={(e) => setTransactionId(e.target.value)}
              disabled={loading}
            />
          </div>
          {subType === 'single' && (
            <>
              <div className='mb-3'>
                <label htmlFor='lineItemId'>Line Item ID</label>
                <input
                  id='lineItemId'
                  type='text'
                  className='form-control'
                  placeholder='Enter line item ID'
                  value={lineItemId}
                  onChange={(e) => setLineItemId(e.target.value)}
                  disabled={loading}
                />
              </div>
              <div className='mb-3'>
                <label htmlFor='externalPayableId'>External Payable ID</label>
                <input
                  id='externalPayableId'
                  type='text'
                  className='form-control'
                  placeholder='Enter external payable ID'
                  value={externalPayableId}
                  onChange={(e) => setExternalPayableId(e.target.value)}
                  disabled={loading}
                />
              </div>
            </>
          )}
          <div className='form-check mb-3'>
            <input
              id='forceRepostToClient'
              type='checkbox'
              className='form-check-input'
              checked={forceRepostToClient}
              onChange={(e) => setForceRepostToClient(e.target.checked)}
              disabled={loading}
            />
            <label className='form-check-label' htmlFor='forceRepostToClient'>
              Force repost to client (repost even if already acknowledged)
            </label>
          </div>
          <div className='mb-3'>
            <small className='text-muted'>URL:</small>
            <code className='d-block mt-1'>{getUrl()}</code>
          </div>
          <button
            type='button'
            className='btn btn-primary'
            onClick={handleSubmit}
            disabled={!isValid() || loading}
          >
            {loading ? 'Retrying...' : 'Retry'}
          </button>
        </div>
      )}
    </div>
  );
};

export default WaterRetryForm;
